/**
 * Tabbable Tabs Bootstrap
 *
 * */
let serviceButtons = document.getElementsByClassName('service-button');
let serviceElements = document.getElementsByClassName('service-element');

function handleServiceButtonEvents(button) {
    console.log(button.dataset)
    let serviceID = "service-" + button.dataset.id
    let serviceElement = document.getElementById(serviceID)
    serviceElement.classList.add('show', 'active')
    checkShownElements(serviceID)
}

/**
 * find other shown elements and remove them
 */
function checkShownElements(serviceID) {
    Object.entries(serviceElements).forEach(function (serviceElement) {
        if (serviceElement[1].id !== undefined) {
            if (serviceElement[1].id !== serviceID) {
                serviceElement[1].classList.remove('show', 'active')
            }
        }
    })
}

/**
 * set event listener
 */
function setServiceButtonsEventListeners() {
    Object.entries(serviceButtons).forEach(function (serviceButton) {
        serviceButton[1].addEventListener('click', () => handleServiceButtonEvents(serviceButton[1], false, true))
    })
}

document.addEventListener('DOMContentLoaded', function () {
    /**
     * run some functions for a first init
     */
    setServiceButtonsEventListeners()
});
